gsap.registerPlugin(ScrollTrigger, DrawSVGPlugin)

document.addEventListener('DOMContentLoaded', () => {
  let isTouch = false
  let smoother

  ScrollTrigger.create({})

  if (ScrollTrigger.isTouch !== 1) {
    smoother = true
  } else {
    document.querySelector('body').classList.add('disableHover')
    isTouch = true
  }


// ----------------------
// NAV intro accordions + bespoke link
// ----------------------
const navItems = Array.from(document.querySelectorAll('.home01__navigation__intro'))

const closeItem = (item) => {
  const btn = item.querySelector('button')
  const modal = item.querySelector('.home01__navigation__intro-modal')
  if (btn) btn.classList.remove('open')
  if (modal) modal.style.display = 'none'
}

const openItem = (item) => {
  const btn = item.querySelector('button')
  const modal = item.querySelector('.home01__navigation__intro-modal')
  if (modal) modal.style.display = 'block'
  if (btn) btn.classList.add('open')
}

const closeAllExcept = (keepItem = null) => {
  navItems.forEach((it) => {
    if (keepItem && it === keepItem) return
    closeItem(it)
  })
}

// init: desktop open first intro, mobile all closed
const isDesktop = window.innerWidth >= 600
closeAllExcept(null)

if (isDesktop) {
  const firstIntro = navItems.find((it) => it.dataset.nav === 'intro' && it.querySelector('.home01__navigation__intro-modal'))
  if (firstIntro) openItem(firstIntro)
}

// handlers
navItems.forEach((item) => {
  const btn = item.querySelector('button')
  if (!btn) return

  // bespoke link
  if (item.dataset.nav === 'link' || btn.dataset.href) {
    btn.addEventListener('click', (e) => {
      const href = btn.dataset.href || '/pages/bespoke'
      window.location.href = href
    })
    return
  }

  // intro accordion
  btn.addEventListener('click', (e) => {
    const modal = item.querySelector('.home01__navigation__intro-modal')
    if (!modal) return

    const isOpen = btn.classList.contains('open')

    if (isOpen) {
      closeItem(item)
    } else {
      closeAllExcept(item)
      openItem(item)
    }
  })
})

  // loader
  let loader_entry_tl
  const loaderAnimation = () => {
    gsap.set('.hero__loader-counter-image-1', { opacity: 1 })
    gsap.set('.hero__loader-counter-image-2', { opacity: 1 })
    gsap.set('.hero__loader-counter-squares', { opacity: 1 })

    loader_entry_tl = gsap
      .timeline({ delay: 1 })
      .from(
        '.hero__loader-counter-image-path',
        { duration: 1.5, ease: 'power3.out', drawSVG: 0 },
        0
      )
      .to(
        '.hero__loader-counter-squares',
        { duration: 1.5, ease: 'power3.out', rotate: 180 },
        0
      )
      .to(
        '.hero__loader-counter-image',
        { rotate: 360, duration: 16, ease: 'none', repeat: -1 },
        '>-0.5'
      )
  }

  // icarvs
  const initIkarusScene = () => {
    const canvas = document.querySelector('#ikarus__statue-canvas')
    const hero = document.querySelector('.home01')
    if (!canvas) return

    const tl = gsap.timeline({
      paused: true,
      delay: 0.2,
    })

    const scene = new THREE.Scene()

    const camera = new THREE.PerspectiveCamera(
      27,
      canvas.clientWidth / canvas.clientHeight,
      0.1,
      12
    )

    // start
    camera.position.set(0, 1.5, 3.5)
    camera.rotation.set(0.16, 0, 0)

    tl.to(camera.position, {
      x: 0,
      y: 1.5,
      z: 6.3,
      duration: 3,
      ease: 'power2.out',
    })
      .to(
        camera.rotation,
        {
          x: 0,
          y: 0,
          z: 0,
          duration: 3,
          ease: 'power2.out',
        },
        '<'
      )
      .to('.ikarus__statue-background', { opacity: 0, duration: 1.4 }, '<')

    const renderer = new THREE.WebGLRenderer({
      canvas,
      alpha: true,
      antialias: true,
    })

    renderer.setSize(canvas.clientWidth, canvas.clientHeight)
    renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2))
    renderer.physicallyCorrectLights = true

    // Lights
    const ambientLight = new THREE.AmbientLight(0xf7faff, 0)
    scene.add(ambientLight)

    const directionalLight1 = new THREE.DirectionalLight(0xf7faff, 0)
    directionalLight1.position.set(-8, -3, -7.3)

    const mouseLight2 = new THREE.DirectionalLight(0xf7faff, 0.9)
    mouseLight2.position.set(0, 1.6, 2)

    const directionalLight3 = new THREE.DirectionalLight(0xf7faff, 0)
    directionalLight3.position.set(10, 4, 1)

    tl.to(directionalLight1, { intensity: 4.5, duration: 1.7 }, '<')
    tl.to(directionalLight3, { intensity: 2, duration: 2.2 }, '<')
    tl.to(ambientLight, { intensity: 2.1, duration: 0.3 }, '<')

    scene.add(directionalLight1)
    scene.add(directionalLight3)
    scene.add(mouseLight2)

    // Load Model
    const loadingManager = new THREE.LoadingManager()

    const loaderPercent = { value: 0 } // Persistent loader object
    let percent = 50
    let initialPercentAnimation = null
    let currentProgressTween = null // Active tween tracker

    loadingManager.onStart = (url, itemsLoaded, itemsTotal) => {
      initialPercentAnimation = gsap.to(loaderPercent, {
        value: percent,
        duration: 2,
        ease: 'none',
        delay: 0.5,
        onUpdate: () => {
          document.getElementById('hero__loader-number').textContent = String(
            Math.floor(loaderPercent.value)
          ).padStart(3, '0')
        },
      })
      loaderAnimation()
    }

    loadingManager.onProgress = (url, itemsLoaded, itemsTotal) => {
      if (initialPercentAnimation) {
        initialPercentAnimation.kill()
        initialPercentAnimation = null
      }

      if (currentProgressTween) {
        currentProgressTween.kill()
      }
      percent = Math.round((itemsLoaded / itemsTotal) * 100)

      currentProgressTween = gsap.to(loaderPercent, {
        value: percent,
        duration: 2,
        ease: 'none',
        delay: 0.5,
        onUpdate: () => {
          document.getElementById('hero__loader-number').textContent = String(
            Math.floor(loaderPercent.value)
          ).padStart(3, '0')
        },
        onComplete: () => {
          if (loaderPercent.value === 100) {
            gsap.set('.hero__loader-counter-image-1', { scaleX: -1 })
            gsap.set('.hero__loader-counter-image-2', { scaleX: -1 })

            let loading_tl_1 = gsap.timeline({
              onComplete: () => {
                const numberSplit = new SplitText('#hero__loader-number', {
                  type: 'chars',
                })
                const numberSplitChars = numberSplit.chars

                let loading_tl_2 = gsap
                  .timeline({
                    onComplete: () => {
                      let loading_tl_3 = gsap
                        .timeline({
                          onStart: () => {
                            tl.play()
                          },
                          onComplete: () => {
                            // homeEntryAnimation()
                            // modelGroup_tl.play()

                            const loaderContent = document.querySelector(
                              '.hero__loader-content'
                            )
                            const loaderBackground = document.querySelector(
                              '.hero__loader-background'
                            )

                            loaderContent.remove()
                            loaderBackground.remove()

                            loader_entry_tl.kill()
                            loading_tl_1.kill()
                            loading_tl_2.kill()
                            loading_tl_3.kill()

                            loader_entry_tl = null
                            loading_tl_1 = null
                            loading_tl_2 = null
                            loading_tl_3 = null
                          },
                        })
                        .to(
                          '.hero__loader-background',
                          {
                            opacity: 0,
                            duration: 0.5,
                            ease: 'power1.inOut',
                          },
                          0
                        )
                    },
                  })
                  .to('.hero__loader-counter-squares-el3', {
                    opacity: 0,
                    duration: 0,
                  })
                  .to(
                    '.hero__loader-counter-squares-el1',
                    {
                      opacity: 0,
                      duration: 0,
                    },
                    '>+0.07'
                  )
                  .to(
                    numberSplitChars[0],
                    { opacity: 0, duration: 0 },
                    '>+0.07'
                  )
                  .to(
                    '.hero__loader-counter-squares-el4',
                    {
                      opacity: 0,
                      duration: 0,
                    },
                    '>+0.07'
                  )
                  .to(
                    numberSplitChars[2],
                    { opacity: 0, duration: 0 },
                    '>+0.07'
                  )
                  .to(
                    '.hero__loader-counter-squares-el2',
                    {
                      opacity: 0,
                      duration: 0,
                    },
                    '>+0.07'
                  )
                  .to(
                    '.hero__loader-counter-image-1',
                    { opacity: 0, duration: 0 },
                    '>+0.07'
                  )
                  .to(
                    '.hero__loader-counter-image-2',
                    { opacity: 0, duration: 0 },
                    '<'
                  )
                  .to(
                    numberSplitChars[1],
                    { opacity: 0, duration: 0 },
                    '>+0.07'
                  )
              },
            })
          }
        },
      })
    }

    loadingManager.onError = (url) => {
      console.error(`There was an error loading ${url}`)
    }

    const loader = new THREE.GLTFLoader(loadingManager)
    let model

    const handleMouseEvent = (event) => {
      const mouseX = (event.clientX / window.innerWidth) * 2 - 1
      const mouseY = -(event.clientY / window.innerHeight) * 2 + 1

      // Define target positions
      const targetX = mouseX * 4
      const targetY = 1.6 + mouseY * 2
      // const targetZ = 2 + mouseX * 2

      // Animate light position smoothly with a bit of delay (easing)
      gsap.to(mouseLight2.position, {
        x: targetX,
        y: targetY,
        // z: targetZ,
        duration: 2, // smooth transition over 0.5 seconds
        ease: 'power2.out',
      })
    }

    loader.load(
      'https://cdn.shopify.com/3d/models/918ddd53e878bdb3/Test4.glb',

      (gltf) => {
        model = gltf.scene
        model.scale.set(1, 1, 1)
        scene.add(model)
        const textureLoader = new THREE.TextureLoader(loadingManager)
        const bakedTexture = textureLoader.load(
          'https://cdn.shopify.com/s/files/1/0629/7354/2535/files/ICARVS_TextureBaked_001.jpg?v=1747840104'
        )
        bakedTexture.minFilter = THREE.LinearFilter
        bakedTexture.generateMipmaps = false
        bakedTexture.flipY = false

        model.traverse((child) => {
          if (child.isMesh) {
            child.geometry.computeVertexNormals()

            child.material = new THREE.MeshStandardMaterial({
              map: bakedTexture,
            })
            // child.frustumCulled = true
            // child.material.flatShading = false
            // child.material.flatShading = false
            // child.material.side = THREE.DoubleSide
            // child.material.needsUpdate = true
          }
        })

        //color

        // start
        // modelGroup.add(model)
        // modelGroup.rotation.set(0, -2.5, 0)

        model.rotation.set(0, 1, 0)

        tl.to(
          model.rotation,
          {
            x: 0,
            y: 6.08,
            z: 0,
            duration: 3,
            ease: 'power2.out',
          },
          '<'
        )

          .to('.navigation__entry-top', {
            opacity: 1,
            y: 0,
            duration: 0.5,
            ease: 'power1.out',
          })
          .to(
            '.home01__entry-stager',
            {
              opacity: 1,
              y: 0,
              stagger: 0.1,
              duration: 0.5,
              ease: 'power1.out',
            },
            '<+0.1'
          )
          .to(
            '.home01__navigation__intro-modal',
            {
              opacity: 1,
              y: 0,
              stagger: 0.1,
              duration: 0.5,
              ease: 'power1.out',
            },
            '<+0.1'
          )
          .to(
            '.waitlistPopup__content-form-description-background',
            {
              opacity: 1,
            },
            '<'
          )
          .to('.home01__bottom-message', { y: 0, duration: 0.5 }, '>-0.5')
      },
      undefined,
      (error) => {
        console.error('Error loading model:', error)
      }
    )

    // Animation Loop
    const animate = () => {
      requestAnimationFrame(animate)
      renderer.render(scene, camera)
    }

    animate()

    // Handle Resize
    window.addEventListener('resize', () => {
      camera.aspect = canvas.clientWidth / canvas.clientHeight
      camera.updateProjectionMatrix()
      renderer.setSize(canvas.clientWidth, canvas.clientHeight)
    })

    if (smoother) {
      hero.addEventListener('mousemove', handleMouseEvent)
    } else {
      mouseLight2.position.set(3.027976, 0.112677, 2)
    }
  }

  // form

  const specialCharRegExp = /^[A-Za-z\s]+$/
  const emailRegExp = /^[^\s@]+@[^\s@]+\.[^\s@]+$/

  const validateInput = (
    input,
    isMandatory = false,
    pattern = null,
    errorMessage = ''
  ) => {
    const parent = input.closest('.input')
    const errorHolder = parent.querySelector('.input__error')
    const value = input.value.trim()
    let isValid = true

    errorHolder.textContent = ''

    if (isMandatory && !value) {
      isValid = false
      errorHolder.textContent = 'Field is mandatory'
    } else if (pattern && value && !pattern.test(value)) {
      isValid = false
      errorHolder.textContent = errorMessage || 'Invalid input'
    }

    parent.classList.toggle('filled', Boolean(value))
    parent.classList.toggle('error', !isValid)

    return isValid
  }

  const addValidationListeners = (
    input,
    isMandatory,
    pattern,
    errorMessage,
    onValidationChange
  ) => {
    let isValid = false
    let hasInteracted = false

    const validate = () => {
      isValid = validateInput(input, isMandatory, pattern, errorMessage)
      if (typeof onValidationChange === 'function') {
        onValidationChange(isValid)
      }
      return isValid
    }

    input.addEventListener('blur', () => {
      if (!hasInteracted) {
        hasInteracted = true
        validate()
      }
    })

    const handleInteraction = () => {
      if (hasInteracted) {
        validate()
      }
    }

    input.addEventListener('keyup', handleInteraction)
    input.addEventListener('change', handleInteraction)

    return {
      validate: () => {
        hasInteracted = true
        return validate()
      },
      getIsValid: () => isValid,
    }
  }

  const thankYouRibbon = document.getElementById('thankYouRibbon')

  document.querySelectorAll('.waitlist__forms').forEach((form) => {
    let isSubmitting = false
    const submitButton = form.querySelector('button[type="submit"]')
    const submitButtonText = submitButton.querySelector('span')
    const originalButtonText = submitButtonText.textContent

    const setSubmitButtonState = (isSubmitting) => {
      submitButton.disabled = isSubmitting
      submitButtonText.textContent = isSubmitting
        ? 'Submitting...'
        : originalButtonText
    }

    const nameValidation = addValidationListeners(
      form.querySelector('.waitlistPopup__name'),
      true,
      specialCharRegExp,
      'No special characters allowed'
    )

    const emailValidation = addValidationListeners(
      form.querySelector('.waitlistPopup__email'),
      true,
      emailRegExp,
      'Please enter a valid email'
    )

    const restartInputs = () => {
      // form.querySelector('.waitlistPopup__name').value = ''
      form.querySelector('.waitlistPopup__email').value = ''

      const inputs = form.querySelectorAll('.input')
      inputs.forEach((input) => {
        input.classList.remove('filled')
        input.classList.remove('error')
        input.querySelector('.input__error').textContent = ''
      })
    }

    const scriptURL =
      'https://script.google.com/macros/s/AKfycbx7DlTufI7Gm3iLX5q_gzPSgydQedRfL0eO9flLYLb6wlAtrDC_lpGML1nels49m5cYwQ/exec'

    form.addEventListener('submit', async (event) => {
      isSubmitting = true
      setSubmitButtonState(isSubmitting)
      event.preventDefault()
      const isNameValid = nameValidation.validate()
      const isEmailValid = emailValidation.validate()

      if (isNameValid && isEmailValid) {
        try {
          const formData = new FormData()
          formData.append('name', event.target[0].value)
          formData.append('email', event.target[1].value)

          const response = await fetch(scriptURL, {
            method: 'POST',
            body: formData,
            headers: {
              Accept: 'application/json',
            },
          })

          const result = await response.json()
          if (result.status === 'success') {
            thankYouRibbon.classList.add('active')
            restartInputs()
            setTimeout(() => {
              thankYouRibbon.classList.remove('active')
            }, 5000)
            isSubmitting = false
            setSubmitButtonState(isSubmitting)
          } else {
            alert('Failed to submit the form.')
            isSubmitting = false
            setSubmitButtonState(isSubmitting)
          }
        } catch (error) {
          console.error('Error:', error.message)
          isSubmitting = false
          setSubmitButtonState(isSubmitting)
        }
      } else {
        isSubmitting = false
        setSubmitButtonState(isSubmitting)
      }
    })
  })

  const fontsToCheck = [
    { name: 'AkkuratMono', weight: 400 },
    { name: 'ESAllianz', weight: 400 },
  ]

  document.fonts.ready.then(() => {
    let allFontsLoaded = true

    fontsToCheck.forEach(({ name, weight }) => {
      if (document.fonts.check(`${weight} 16px ${name}`)) {
        // console.log(`${name} (weight: ${weight}) is loaded!`)
      } else {
        // console.log(`${name} (weight: ${weight}) is not available.`)
        allFontsLoaded = false
      }
    })

    if (allFontsLoaded) {
      initIkarusScene()
    }
  })
})
